import React, { useCallback } from 'react'

import { SxProps, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { APP_PATHS } from '../../routes/paths'
import { CustomButton } from '../CustomButton'
import { EmptyTable } from '../Table/EmptyTable'

export const EmptyAccountData = ({ sx }: { sx?: SxProps }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { spacing } = useTheme()

  const handleClick = useCallback(() => {
    navigate(APP_PATHS.settings, { state: { creatingNewAccount: true } })
  }, [])

  return (
    <EmptyTable
      sx={sx}
      message={t(
        'emptyAccountsData',
        "It looks like you haven't added any trading accounts or recorded any trades yet. To get started, click the button below to add a new account",
      )}
    >
      <CustomButton sx={{ margin: spacing(5, 0) }} onClick={handleClick}>
        {t('addAccount', 'Add account')}
      </CustomButton>
    </EmptyTable>
  )
}
